import {
  getGroups,
  setGroupByUrl,
} from '@sonifi/wb-group/services/group.service';
import {
  checkUserLogged,
  getAuthCode,
  getTransferToken,
  loginSSO,
  loginViaAuthCode,
  logout,
} from '@sonifi/wb-login/services/keyMaster.service';
import { getProducts } from '@sonifi/wb-products/services/products.service';
import { GROUPS_KEYS } from '@sonifi/wb-group/store/groupsConstants';
import { setAppLoaded } from '../store/application/applicationSlice';
import { cleanJobsSlice } from '@sonifi/wb-admin/store/jobs/jobsSlice';
import { cleanBrandingSlice } from '@sonifi/wb-branding/store/brandingSlice';
import { cleanFormErrorsSlice } from '@sonifi/wb-widget/store/formErrors/formErrorsSlice';
import { cleanFilesSlice } from '@sonifi/wb-widget/store/file/fileSlice';
import { cleanGroupsSlice } from '@sonifi/wb-group/store/groupsSlice';
import { cleanHomeSlice } from '@sonifi/wb-home/store/homeSlice';
import { cleanAllMediaSlice } from '../../wb-media/store/mediaSlice';
import {
  cleanNotifierSlice,
  setAlert,
} from '@sonifi/wb-notifier/store/notifierSlice';
import { cleanSelfServiceSlice } from '@sonifi/wb-remote-ordering/store/selfServiceSlice';
import { cleanTableConfigSlice } from '@sonifi/wb-widget/store/tableConfig/tableConfigSlice';
import { cleanUserSlice } from '@sonifi/wb-user/store/userSlice';
import { cleanUsersSlice } from '@sonifi/wb-admin/store/users/usersSlice';
import { cleanPropertiesSlice } from '@sonifi/wb-admin/store/properties/propertiesSlice';
import { cleanGuestRequestMenuSlice } from '@sonifi/wb-guest-request/store/menu/guestRequestMenuSlice';
import { cleanGuestRequestOrdersSlice } from '@sonifi/wb-guest-request/store/orders/guestRequestOrdersSlice';
import { cleanGuestRequestSettingsSlice } from '@sonifi/wb-guest-request/store/settings/guestRequestSettingsSlice';
import { cleanHappeningsSlice } from '@sonifi/wb-happenings/store/happeningsSlice';
import { cleanHappeningsSlideEditorSlice } from '@sonifi/wb-happenings/store/happeningsSlideEditorSlice';
import { cleanIrdSettingsSlice } from '@sonifi/wb-in-room-dining/store/settings/irdSettingsSlice';
import { cleanIrdOrdersSlice } from '@sonifi/wb-in-room-dining/store/orders/irdOrdersSlice';
import { defaultConfig } from '../../../config-env';

const checkMaintenanceMessage = () => (dispatch) => {
  const maintenanceMessage = defaultConfig.maintenanceMessage;
  if (maintenanceMessage) {
    dispatch(
      setAlert({
        duration: 0,
        content: maintenanceMessage,
        type: 'info',
        show: true,
        dismissable: true,
      }),
    );
  }
};

export const initApp = (groupId) => async (dispatch) => {
  dispatch(setAppLoaded(false));
  dispatch(checkMaintenanceMessage());
  const isLogged = await dispatch(checkUserLogged());

  const authCode = getAuthCode();
  if (authCode) {
    dispatch(loginViaAuthCode(authCode));
    dispatch(setAppLoaded(true));
    return;
  }

  const { transferToken, isValid } = getTransferToken();

  if (transferToken) {
    isValid
      ? dispatch(loginSSO(transferToken))
      : dispatch(logout({ usesSSO: true, redirectNoAuth: true }));
    dispatch(setAppLoaded(true));
    return;
  }

  if (isLogged) {
    await Promise.all([
      dispatch(getGroups({ groupKey: GROUPS_KEYS.allGroups })),
      dispatch(getProducts()),
    ]);
    dispatch(setGroupByUrl(groupId));
  }
  dispatch(setAppLoaded(true));
};

export const cleanWBState = () => (dispatch) => {
  dispatch(cleanUserSlice());
  dispatch(cleanHomeSlice());
  dispatch(cleanGroupsSlice());
  dispatch(cleanJobsSlice());
  dispatch(cleanFilesSlice());
  dispatch(cleanFormErrorsSlice());
  dispatch(cleanNotifierSlice());
  dispatch(cleanSelfServiceSlice());
  dispatch(cleanTableConfigSlice());
  dispatch(cleanBrandingSlice());
  dispatch(cleanAllMediaSlice());
  dispatch(cleanUsersSlice());
  dispatch(cleanPropertiesSlice());
  dispatch(cleanHappeningsSlice());
  dispatch(cleanHappeningsSlideEditorSlice());
  dispatch(cleanGuestRequestMenuSlice());
  dispatch(cleanGuestRequestOrdersSlice());
  dispatch(cleanGuestRequestSettingsSlice());
  dispatch(cleanIrdOrdersSlice());
  dispatch(cleanIrdSettingsSlice());
};
